import { render, staticRenderFns } from "./ex-item.vue?vue&type=template&id=0deace3f&scoped=true"
import script from "./ex-item.vue?vue&type=script&lang=js"
export * from "./ex-item.vue?vue&type=script&lang=js"
import style0 from "./ex-item.vue?vue&type=style&index=0&id=0deace3f&prod&scoped=true&lang=scss"
import style1 from "./ex-item.vue?vue&type=style&index=1&id=0deace3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0__ejs@2._efqjtiugzhgbjdza5v3l2szjuq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deace3f",
  null
  
)

export default component.exports